document.addEventListener('DOMContentLoaded', function() {
  const trigger = document.querySelector('.size-chart-trigger');
  const modal = document.querySelector('.size-chart-modal');

  if (!trigger || !modal) return;

  // Modal açma
  trigger.addEventListener('click', () => {
    modal.style.display = 'block';
  });

  // Modal kapatma
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  });

  // ESC tuşu ile kapatma
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      modal.style.display = 'none';
    }
  });
});